const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTION_ACTIONS)
const groupPrefixStore = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)

export const apiPromotionActions = {
	fetchPromotionActionsTypes: async () => {
		const { data } = await apiCommon<IPromotionAction[]>(`${groupPrefix}/types`, {
			method: 'GET',
		})
		return { data: data.map(PromotionAction) }
	},

	fetchPromotionAction: async (actionID: number) => {
		const { data } = await apiCommon<IPromotionAction>(`${groupPrefix}/${actionID}`, {
			method: 'GET',
		})
		return { data: PromotionAction(data) }
	},

	storePromotionAction: async (promotionID: number, type: any, configuration: any) => {
		const { data } = await apiCommon<IPromotionAction>(`${groupPrefixStore}/${promotionID}/promotion-actions`, {
			method: 'POST',
			body: { type, configuration },
		})
		return PromotionAction(data)
	},

	updatePromotionAction: async (actionID: number, type: any, configuration: any) => {
		const { data } = await apiCommon<IPromotionAction>(`${groupPrefix}/${actionID}`, {
			method: 'PUT',
			body: { type, configuration },
		})
		return PromotionAction(data)
	},

	deletePromotionAction: async (actionID: number) =>
		await apiCommon<IPromotionAction>(`${groupPrefix}/${actionID}`, { method: 'DELETE' }),
}
